import React from 'react'

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={60} height={60} viewBox="0 0 1024 1024" {...props}>
      <path d="M760.499 493.901c-9.995-9.997-26.206-9.997-36.203 0L512 706.195V128c0-14.138-11.462-25.6-25.6-25.6s-25.6 11.462-25.6 25.6v578.195L248.502 493.901c-9.998-9.997-26.206-9.997-36.205 0-9.997 9.995-9.997 26.206 0 36.203l256 256c5 4.997 11.55 7.496 18.102 7.496s13.102-2.499 18.102-7.501l256-256c9.997-9.995 9.997-26.203-.003-36.198z" />
      <path d="M896 972.8H76.8C34.453 972.8 0 938.349 0 896V793.6C0 779.461 11.462 768 25.6 768s25.6 11.461 25.6 25.6V896c0 14.115 11.485 25.6 25.6 25.6H896c14.115 0 25.6-11.485 25.6-25.6V793.6c0-14.139 11.461-25.6 25.6-25.6s25.6 11.461 25.6 25.6V896c0 42.349-34.451 76.8-76.8 76.8z" />
    </svg>
  )
}

export default SvgComponent
